var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryVe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_7598)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_7598",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_7598)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.3333H28V6.66663H0V13.3333Z",
    fill: "#063191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V13.3334H0V20Z",
    fill: "#E2213B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 9.33333C14.3681 9.33333 14.6666 9.03486 14.6666 8.66667C14.6666 8.29848 14.3681 8 13.9999 8C13.6317 8 13.3333 8.29848 13.3333 8.66667C13.3333 9.03486 13.6317 9.33333 13.9999 9.33333ZM11.3333 10C11.7014 10 11.9999 9.70152 11.9999 9.33333C11.9999 8.96514 11.7014 8.66667 11.3333 8.66667C10.9651 8.66667 10.6666 8.96514 10.6666 9.33333C10.6666 9.70152 10.9651 10 11.3333 10ZM17.3333 9.33333C17.3333 9.70152 17.0348 10 16.6666 10C16.2984 10 15.9999 9.70152 15.9999 9.33333C15.9999 8.96514 16.2984 8.66667 16.6666 8.66667C17.0348 8.66667 17.3333 8.96514 17.3333 9.33333ZM9.99992 12C10.3681 12 10.6666 11.7015 10.6666 11.3333C10.6666 10.9651 10.3681 10.6667 9.99992 10.6667C9.63173 10.6667 9.33325 10.9651 9.33325 11.3333C9.33325 11.7015 9.63173 12 9.99992 12ZM18.6666 11.3333C18.6666 11.7015 18.3681 12 17.9999 12C17.6317 12 17.3333 11.7015 17.3333 11.3333C17.3333 10.9651 17.6317 10.6667 17.9999 10.6667C18.3681 10.6667 18.6666 10.9651 18.6666 11.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.66667H28V0H0V6.66667Z",
    fill: "#FFD044"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_7598"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryVe);
export default __webpack_public_path__ + "static/media/Country=VE.cda52ce3ba72f04d728a850d601d5b65.svg";
export { ForwardRef as ReactComponent };